var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 281.549,
    height: 104.029,
    viewBox: "0 0 281.549 104.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1.025,
    x2: 0.5,
    y2: -0.25,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd16c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3bd1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1.025,
    x2: 0.5,
    y2: -0.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 1.648,
    x2: 0.5,
    y2: -1.479,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4729",
    "data-name": "Group 4729",
    transform: "translate(-378.57 157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(492.57 -157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M41.827,71.416H34.343a5.772,5.772,0,0,1-5.773-5.773V20.14L36,20.191a5.767,5.767,0,0,1,5.731,5.762l.021,9.218a10.152,10.152,0,0,0-1.415.513,9.611,9.611,0,0,0-5.352,6.131c-.656,2.307-.779,6.029,2.358,10.674a22.389,22.389,0,0,0,1.887,2.4,31.741,31.741,0,0,0,2.574,2.553l.031,13.975Z",
    transform: "translate(-28.57 -20.13)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M70.639,20.14V65.633a5.772,5.772,0,0,1-5.773,5.772H57.3l.031-13.985A30.17,30.17,0,0,0,59.9,54.868a21.888,21.888,0,0,0,1.876-2.389c3.127-4.634,3-8.356,2.348-10.674a9.825,9.825,0,0,0-6.757-6.644l-.051-9.228a5.778,5.778,0,0,1,5.773-5.8h7.536Z",
    transform: "translate(-27.843 -20.13)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M59.413,50.1a18.421,18.421,0,0,1-1.589,2.03,36.876,36.876,0,0,1-8.141,6.552,37.34,37.34,0,0,1-8.131-6.541,20.918,20.918,0,0,1-1.589-2.03c-3.968-5.875-1.815-10.212,1.569-11.74a6.166,6.166,0,0,1,8.161,2.7,6.164,6.164,0,0,1,8.172-2.686c3.373,1.528,5.526,5.855,1.558,11.73Z",
    transform: "translate(-28.336 -19.683)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(378.57 -93.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M109.188,26.21h5.669V47.668h10.906v4.917H109.18V26.21Z",
    transform: "translate(-109.18 -21.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M140.325,32.928c3.016,0,8.921.955,8.921,10.154,0,7.536-4.207,11.143-9.521,11.143s-8.845-3.413-8.845-10.594c0-8.287,5.271-10.712,9.436-10.712Zm3.252,10.746c0-4.283-.912-6.741-3.489-6.741s-3.607,2.458-3.607,6.066.515,7.181,3.531,7.181c2.534,0,3.573-2.458,3.573-6.5Z",
    transform: "translate(-112.548 -22.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M172.57,33.628a33.894,33.894,0,0,1,1.309,8.887c0,7.493-3.295,11.776-9.715,11.776-4.883,0-7.214-2.264-7.214-7.138V33.628h5.55V46.283c0,2.18.161,3.726,2.264,3.726,2.9,0,3.726-3.649,3.726-7.223a37.991,37.991,0,0,0-1.352-9.166h5.432Z",
    transform: "translate(-116.594 -22.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M197.158,38.717c0,5.99-6.066,7.181-10.864,7.375a4.32,4.32,0,0,0,4.562,3.928,8.867,8.867,0,0,0,4.959-1.706l1.588,3.692a12.5,12.5,0,0,1-7.257,2.222c-6.741,0-9.436-4.207-9.436-10.154s3.371-11.143,9.876-11.143c4,0,6.581,2.019,6.581,5.8Zm-6.86-1.9c-2.695,0-4.123,2.661-4.241,5.39,2.577-.076,6.268-.71,6.268-3.447a1.853,1.853,0,0,0-2.019-1.943Z",
    transform: "translate(-120.282 -22.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M228.115,23.37V52.143h-6.184V40.24H210.982v11.9H204.79V23.37h6.192V34.834h10.948V23.37Z",
    transform: "translate(-124.02 -20.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M257.309,48.912l.431,4.368h-5.153l-.3-2.2-.22-.042a6.621,6.621,0,0,1-5.8,2.855c-6.277,0-8.4-4.756-8.4-10.6,0-7.612,3.81-12.6,11.464-12.6a25.609,25.609,0,0,1,7.958,1.605V48.912Zm-5.964-13.28a7.17,7.17,0,0,0-2.729-.473c-3.548,0-4.756,3.548-4.756,7.789,0,3.506.735,6.581,3.937,6.581a3.348,3.348,0,0,0,3.548-3.244V35.64Z",
    transform: "translate(-129.154 -21.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M273.3,62.371H267.29V32.212a31.9,31.9,0,0,1,9.09-1.512c6.927,0,10.3,3.894,10.3,11.472s-3.59,11.768-9.394,11.768a9.089,9.089,0,0,1-3.979-.955V62.38Zm2.2-26.915a10.2,10.2,0,0,0-2.2.262V48.263a5.885,5.885,0,0,0,3.033.87c3.328,0,4.283-3.464,4.283-6.623,0-4.156-1.343-7.054-5.1-7.054Z",
    transform: "translate(-133.721 -21.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M301.325,62.371H295.31V32.212A31.9,31.9,0,0,1,304.4,30.7c6.927,0,10.3,3.894,10.3,11.472S311.108,53.94,305.3,53.94a9.089,9.089,0,0,1-3.979-.955V62.38Zm2.2-26.915a10.2,10.2,0,0,0-2.2.262V48.263a5.884,5.884,0,0,0,3.033.87c3.328,0,4.283-3.464,4.283-6.623,0-4.156-1.343-7.054-5.1-7.054Z",
    transform: "translate(-138.07 -21.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M326.408,20.3a3.2,3.2,0,0,1,3.379,3.16,3.132,3.132,0,0,1-3.379,3.16,3.089,3.089,0,0,1-3.328-3.16A3.165,3.165,0,0,1,326.408,20.3Zm-2.982,31.375V29.736h6.015V51.675Z",
    transform: "translate(-142.38 -20.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M336.839,53.288V35.412l-.389-4.072h5.018l.431,2.594a7.66,7.66,0,0,1,6.53-3.244c4.283,0,6.877,2.425,6.877,7.62V53.28h-6.015v-13.8c0-2.382-.389-4.156-2.686-4.156a3.741,3.741,0,0,0-3.768,3.894V53.28h-6.015Z",
    transform: "translate(-144.455 -21.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M381.66,37.021c0,6.53-6.623,7.831-11.861,8.051a4.71,4.71,0,0,0,4.976,4.283,9.645,9.645,0,0,0,5.407-1.859l1.732,4.021A13.674,13.674,0,0,1,374,53.942c-7.358,0-10.3-4.587-10.3-11.075s3.675-12.156,10.771-12.156c4.368,0,7.181,2.2,7.181,6.319Zm-7.485-2.078c-2.94,0-4.5,2.9-4.629,5.888,2.813-.084,6.834-.777,6.834-3.768A2.023,2.023,0,0,0,374.175,34.942Z",
    transform: "translate(-148.684 -21.916)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M388.86,47.4a13.675,13.675,0,0,0,6.319,2.12c1.605,0,2.771-.65,2.771-2.289s-1.554-2.12-3.421-2.686c-3.244-.955-6.53-2.2-6.53-6.792s3.633-7.054,8.093-7.054a11.783,11.783,0,0,1,8.178,3.16L401.5,37.365a8.277,8.277,0,0,0-5.06-2.289c-1.428,0-2.593.566-2.593,1.994,0,1.69,1.428,2.247,3.379,2.855,3.159,1,6.708,2.163,6.708,6.665,0,4.891-3.421,7.358-8.439,7.358a15.222,15.222,0,0,1-8.262-2.289l1.647-4.241Z",
    transform: "translate(-152.337 -21.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M411.2,47.4a13.674,13.674,0,0,0,6.319,2.12c1.605,0,2.771-.65,2.771-2.289s-1.554-2.12-3.421-2.686c-3.244-.955-6.53-2.2-6.53-6.792s3.633-7.054,8.093-7.054a11.783,11.783,0,0,1,8.177,3.16l-2.771,3.506a8.277,8.277,0,0,0-5.06-2.289c-1.428,0-2.594.566-2.594,1.994,0,1.69,1.428,2.247,3.379,2.855,3.16,1,6.708,2.163,6.708,6.665,0,4.891-3.421,7.358-8.439,7.358a15.222,15.222,0,0,1-8.262-2.289l1.647-4.241Z",
    transform: "translate(-155.804 -21.914)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14084",
    "data-name": "Path 14084",
    d: "M.724-3.409A4.06,4.06,0,0,1-1.34-3.925a3.687,3.687,0,0,1-1.4-1.421A4.136,4.136,0,0,1-3.248-7.4a4.122,4.122,0,0,1,.506-2.064,3.707,3.707,0,0,1,1.4-1.412,4.06,4.06,0,0,1,2.064-.516,3.968,3.968,0,0,1,2.035.516A3.727,3.727,0,0,1,4.151-9.464,4.122,4.122,0,0,1,4.657-7.4a4.136,4.136,0,0,1-.506,2.054A3.708,3.708,0,0,1,2.759-3.925,3.968,3.968,0,0,1,.724-3.409Zm.72-1.928L.276-7.245h1.09L2.632-5.337ZM.724-4.188A3.174,3.174,0,0,0,2.369-4.6,2.79,2.79,0,0,0,3.44-5.736,3.555,3.555,0,0,0,3.82-7.4a3.5,3.5,0,0,0-.38-1.655,2.872,2.872,0,0,0-1.071-1.139,3.116,3.116,0,0,0-1.645-.419,3.22,3.22,0,0,0-1.665.419,2.9,2.9,0,0,0-1.1,1.139A3.425,3.425,0,0,0-2.43-7.4a3.483,3.483,0,0,0,.389,1.665A2.817,2.817,0,0,0-.941-4.6,3.28,3.28,0,0,0,.724-4.188Zm-1.6-1.149V-9.523H1.035a1.477,1.477,0,0,1,1.042.35,1.235,1.235,0,0,1,.38.954,1.211,1.211,0,0,1-.38.935,1.477,1.477,0,0,1-1.042.35H.12v1.6ZM.12-7.712h.8a.672.672,0,0,0,.389-.107.406.406,0,0,0,.156-.36.38.38,0,0,0-.156-.35.722.722,0,0,0-.389-.1H.12Z",
    transform: "translate(655.462 -80.448)",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile_logo.73fd8aea65d71b5c235057f37d212238.svg";
export { ForwardRef as ReactComponent };